// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__fJ3ph","checkboxCol":"Table_checkboxCol__3vweB","emailCol":"Table_emailCol__1lpy3","actionCol":"Table_actionCol__rk8X_"};